import styled from 'styled-components'
import { default as VARIABLES } from '../../themes/styles/variables'

// Wrapper
// ============================================================
export const InputTextareaStyle = styled.div`
  /* Parent styles
  ------------------------------- */
  display: flex;
  flex-wrap: wrap;
  width: 100%;

  /* Child element styles
  ------------------------------- */
  .textarea {
    border-radius: ${VARIABLES.BORDER_RADIUSES.XS};
    border: ${VARIABLES.BORDER_WIDTHS.MN} solid ${VARIABLES.COLORS.GRAY_2};
    background-color: white;
    flex: 1 1 auto;
    min-height: 125px;
    min-width: 350px;
    max-width: 100%;
    max-height: 70vh;
    font-size: ${VARIABLES.TYPOGRAPHYS.FONT_SIZES_PX.MD};
    color: ${VARIABLES.COLORS.GRAY_3};
    padding: 8px 14px;
    resize: vertical;

    ::-webkit-input-placeholder {
      color: ${VARIABLES.COLORS.GRAY_5};
    }

    :-ms-input-placeholder {
      color: ${VARIABLES.COLORS.GRAY_5};
    }

    ::placeholder {
      color: ${VARIABLES.COLORS.GRAY_5};
    }

    /* width */
    ::-webkit-scrollbar {
      width: 5px;
      margin-right: -8px;
    }

    /* Track */
    ::-webkit-scrollbar-track {
      background: ${VARIABLES.COLORS.GRAY_2};
    }

    /* Handle */
    ::-webkit-scrollbar-thumb {
      background: ${VARIABLES.COLORS.BLUE_4};
    }

    /* Handle on hover */
    ::-webkit-scrollbar-thumb:hover {
      background: ${VARIABLES.COLORS.BLUE_1};
    }
  }

  .label {
    color: #1f2937;
    font-size: 14px;
    font-weight: 600;
    margin-bottom: 10px;
  }

  /* Modifiers
  ------------------------------- */
  &.theme-blue {
    .textarea {
      color: ${VARIABLES.COLORS.BLUE_1};
    }

    .label {
      color: #1f2937;
    }
  }

  /* State
  ------------------------------- */
  &.is-disabled {
    .textarea {
      background-color: ${VARIABLES.COLORS.GRAY_8};
      color: ${VARIABLES.COLORS.GRAY_10};
      resize: none;
    }
  }

  &.is-read-only {
    .textarea {
      background-color: ${VARIABLES.COLORS.GRAY_8};
      color: ${VARIABLES.COLORS.GRAY_10};
      resize: none;
      cursor: default;
    }
  }
  &.is-error {
    .textarea {
      border-color: ${VARIABLES.COLORS.RED_1};
    }
  }

  &.is-success {
    .textarea {
      border-color: ${VARIABLES.COLORS.GREEN_2};
    }
  }

  /* Media queries
  ------------------------------- */
  @media all and (max-width: 1600.98px) {
    .textarea {
      min-width: 0;
      font-size: 16px;
      min-height: 109px;
    }
  }

  @media all and (max-width: 1440.98px) {
    .textarea {
      font-size: 15px;
      min-height: 102px;
    }
  }

  @media all and (max-width: 1366.98px) {
    .textarea {
      font-size: 14px;
      min-height: 95px;
    }
  }

  @media all and (max-width: 1280.98px) {
    .textarea {
      font-size: 13px;
      padding: 7px 10px;
    }
  }

  @media all and (max-width: 1024.98px) {
    .textarea {
      font-size: 12px;
    }
  }
`
// border-color: #DD4534;
